import * as unAuthAppBarActions from "./unAuthAppBarActions";
import * as unAuthActions from "./unAuthActions";

export const rootUnAuthActions = {
  ...unAuthAppBarActions,
  ...unAuthActions,
};
